import { registerPlugin } from '@capacitor/core';

const AppUpdater = registerPlugin('AppUpdater');

export default AppUpdater;
